import { render, staticRenderFns } from "./ShowCompany.vue?vue&type=template&id=5073f77c&scoped=true&lang=pug&"
import script from "./ShowCompany.vue?vue&type=script&lang=js&"
export * from "./ShowCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073f77c",
  null
  
)

export default component.exports